module.exports = __webpack_public_path__ + "img/xueShan3.f6cdb7bb.png";